<template>
  <main>
    <b-row class="data-format-setting mt-1">
      <b-col md="3" class="text_gray">
        <p class="label-bold ml-3">{{ settingTitle }}</p>
      </b-col>
      <b-col :class="['table-data-format-setting', {'table-list-upload': startIndex === 0}]" >
        <table class="table table-list-master">
          <thead>
            <th>ファイル名</th>
            <th class="d-flex">プレフィックス
              <img
                v-b-tooltip.hover.top.html="{
                  variant: 'secondary',
                  animation: true
                }"
                title="CSVファイルアップロード/ダウンロード時に種類を特定するため、ファイル名の先頭文字を1〜32文字で設定します。_（アンダースコア）/（スラッシュ）-（ハイフン）＼（バックスラッシュ）は使用不可です。"
                src="../../assets/images/help_outline_gray_24dp.svg"
                alt="Question mark"
                class="question_mark"
              />
            </th>
            <th>1行目のヘッダ</th>
            <th>マッピング</th>
          </thead>
          <tbody>
            <tr v-for="(csvType, index) in csvTypeList" :key="`prefix-${getIndex(index)}`">
              <template v-if="csvType.csvNo != 'rack'">
                <td class="master-name">
                  {{ csvType.type}}
                  <span v-if="csvType.isRequiredMappingFlag" class="required">必須</span>
                </td>
                <td class="master-prefix">
                  <input-text-component
                    :id="`prefix-${getIndex(index)}`"
                    :ref="`prefix-${getIndex(index)}`"
                    :refInput="`prefix-${getIndex(index)}`"
                    :classCustom="{
                      'form-control text_prefix': true,
                      'border border-danger': prefixErrMsg[index],
                      'border-danger bg-danger-outline':
                        errorMsgRequiredPrefixCsv[index]
                    }"
                    placeholder="ファイル名の先頭文字（1～32文字）"
                    @change="updateItem(csvType)"
                    v-model="csvType.filenamePrefix"
                    :maxlength="32"
                    @onInput="preventInvalidInputValue(...arguments, index)"
                    @onKeydown="onKeydown(...arguments, index)"
                    @onPaste="onPaste(...arguments, index)"
                  />
                  <span
                    class="text-danger"
                    :ref="`prefix-errMsg-${getIndex(index)}`"
                    >{{ prefixErrMsg[index] }}
                  </span>
                  <span
                    class="text-danger"
                    :ref="`prefix-errMsg-${getIndex(index)}`"
                    >{{
                      errorMsgRequiredPrefixCsv[index]
                        ? csvType.type +
                          errorMsgRequiredPrefixCsv[index]
                        : ''
                    }}
                  </span>
                </td>
                <td>
                  <div
                    :class="[
                      { isActiveChbx: isChecked(csvType.hederPresenceFlag) },
                      'boxCheckBox checkbox-header'
                    ]"
                  >
                    <!-- ラジオ ON -->
                    <label class="custom_checkbox">
                      <input
                        type="checkbox"
                        style="position: relative"
                        :name="`${csvType.csvNo}`"
                        @change="includeTitle(index)"
                        v-bind="{
                          checked: isChecked(csvType.hederPresenceFlag)
                        }"
                        :id="`on_${getIndex(index)}`"
                      />
                      <span class="label_name text-nowrap">含む</span>
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </td>
                <td>
                  <b-button
                    v-if="isMappingButtonDisplayed(csvType.csvNo)"
                    @click="onClickRoute($event, csvType.csvNo)"
                    class="btn-link"
                    :class="{'done': csvType.mapped}">
                    <span v-if="csvType.mapped">設定済</span>
                    <span v-else>未設定</span>
                    <i class="material-icons">keyboard_arrow_right</i>
                  </b-button>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
  </main>
</template>

<script>
import InputTextComponent from '../custom-components/InputTextComponent.vue'
import AppConstants from '../../constants/app.constants'
import RouterUtils from '../../_helpers/router.util'
export default {
  props: {
    settingTitle: {
      type: String,
      default: ''
    },
    csvTypeList: {
      type: Array | Object,
      default: null
    },
    startIndex: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      prefixErrMsg: [],
      errorMsgRequiredPrefixCsv: []
    }
  },
  components: { InputTextComponent },
  methods: {
    getIndex(index) {
      return this.startIndex + index
    },
    updateItem(data) {
      this.$emit('update-item', data)
    },
    isChecked(value) {
      if (value === 1) return true
      else return false
    },
    /**
     * 特定の入力フィールドに対する警告メッセージを表示します。
     * @param {number} index 警告を表示する入力フィールドのインデックス
     */
    showWarningMessage(index) {
      const input = document.getElementById(`prefix-${this.getIndex(index)}`)
      if (input) {
        input.setCustomValidity(`_（アンダースコア）/（スラッシュ）-（ハイフン）＼（バックスラッシュ）は使用不可です。`)
        input.reportValidity()
      }
    },
    /**
     * 指定された正規表現に基づいて、指定された値に禁止文字が含まれているかどうかを確認します。
     * @param {string} value 禁止文字をチェックする値
     * @returns {boolean} 値に禁止文字が含まれている場合は true。 それ以外の場合は false
     */
    containsProhibitedCharacters(value) {
      return value && value.match(AppConstants.CSV_PREFIX_PROHIBITED_CHAR_CODES_REGEX)
    },
    /**
     * キーダウンイベントを処理し、禁止された文字コード正規表現に一致する場合に入力を禁止します。
     * @param {Event} event キーダウン イベント
     * @param {number} index 操作に関連するインデックス
     */
    onKeydown(event, index) {
      if (this.containsProhibitedCharacters(event.key)) {
        this.showWarningMessage(index)
        event.preventDefault()
        event.stopPropagation()
      }
    },
    /**
     * 禁止された文字コード正規表現に一致する文字を削除することで、無効な入力値を防止します。
     * @param {string} value チェックする入力値
     * @param {number} index 操作に関するインデックス
     */
    preventInvalidInputValue(value, index) {
      if (this.containsProhibitedCharacters(value)) {
        this.showWarningMessage(index)
        setTimeout(() => {
          this.csvTypeList[index].filenamePrefix = value.replaceAll(AppConstants.CSV_PREFIX_PROHIBITED_CHAR_CODES_REGEX, '')
        }, 20)
      }
    },
    /**
     * 禁止文字を削除し、入力値を更新することで、貼り付けイベントを処理します
     * @param {Event} event 貼り付けイベント
     * @param {number} index 操作に関するインデックス
     * @returns {boolean} 処理後に true を返します
     */
    onPaste(event, index) {
      const replacedStr = event.clipboardData
        .getData('text/plain')
        .replaceAll(AppConstants.CSV_PREFIX_PROHIBITED_CHAR_CODES_REGEX, '')
      let str = this.csvTypeList[index].filenamePrefix ? this.csvTypeList[index].filenamePrefix : ''
      const selectionStart = this.$refs[`prefix-${this.getIndex(index)}`][0].$refs[`prefix-${this.getIndex(index)}`].selectionStart
      const selectionEnd = this.$refs[`prefix-${this.getIndex(index)}`][0].$refs[`prefix-${this.getIndex(index)}`].selectionEnd
      setTimeout(() => {
        this.csvTypeList[index].filenamePrefix = [
          str.slice(0, selectionStart) +
            replacedStr +
            str.slice(selectionEnd, str.length)
        ].join('')
      }, 20)
      return true
    },
    /** インデックスに基づいてヘッダ有無フラグの値をリセットします
     * @param {number} index レコードのインデックス
     */
    includeTitle(index) {
      if (this.csvTypeList[index].hederPresenceFlag === 0) {
        this.$set(this.csvTypeList[index], 'hederPresenceFlag', 1)
      } else {
        this.$set(this.csvTypeList[index], 'hederPresenceFlag', 0)
      }
      this.$emit('update-item', this.csvTypeList[index])
    },
    /** CSV番号に基づいて対応するマッピングページに移動します
     * @param {string} csvNo CSV番号
     */
    onClickRoute(e, csvNo) {
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      let routeName = AppConstants.MAPPING_ROUTER_LIST[csvNo]
      RouterUtils.goToRouterName(routeName)
    },
    /** ハンドル表示マッピング ボタン
     * @param {string} csvNo CSV番号
     * @return {boolean} true: ディスプレイがある; false: 表示されない
     */
    isMappingButtonDisplayed(csvNo) {
      return Object.keys(AppConstants.MAPPING_ROUTER_LIST).includes(csvNo)
    },
    validateData() {
      let errIndex = []
      let errRequiredPrefixCsv = []

      // Refresh prefix error message array
      this.prefixErrMsg.fill('')
      this.errorMsgRequiredPrefixCsv.fill('')
      // Checking valid prefix
      this.csvTypeList.forEach((csvType, index) => {
        if (!csvType.filenamePrefix) {
          errRequiredPrefixCsv.push(index)
        }
        if (this.containsProhibitedCharacters(csvType.filenamePrefix)) {
          errIndex.push(index)
        }
      })

      // すべての必須フィールドを確認してください
      if (errRequiredPrefixCsv.length > 0) {
        errRequiredPrefixCsv.map(index =>
          this.$set(this.errorMsgRequiredPrefixCsv, index, 'は必須項目です。')
        )
        return
      }
      if (errIndex.length > 0) {
        errIndex.map(index =>
          this.$set(
            this.prefixErrMsg,
            index,
            '_（アンダースコア）/（スラッシュ）-（ハイフン）＼（バックスラッシュ）は使用不可です。'
          )
        )
        return
      }
      return !(errIndex.length || errRequiredPrefixCsv.length)
    }
  }
}
</script>

<style lang="scss" scoped>
@include set-style-on-visible-sw-menu('.data-format-setting') {
  display: block;
};
.data-format-setting {
  @include media-breakpoint-default() {
    display: block;
  }
  .label-bold {
    font-weight: bold;
    color: #252422;
    white-space: nowrap;
  }
  .table-data-format-setting {
    overflow-x: hidden;
    .table-list-master {
      .check-required {
        width: 20px;
        @include responsive-fs(20);
        color: #4E66A6;
      }

      border-collapse: separate;
      border-spacing: 0px;

      th {
        @include responsive-fs(12);
        white-space: nowrap;
        border-top: none;
        border-bottom: 2px solid #dee2e6;
      }
      tr:first-child {
        td {
          @media only screen and (min-width: 1921px) {
            border-top: 1px solid #dee2e6;
          }
        }
      }
      td {
        vertical-align: middle;
        white-space: nowrap;
        border-bottom: 1px solid #dee2e6;
        border-top: none;
        &.master-name {
          @include responsive-fs(18);
          color: #252422;
          font-weight: 400;
          width: 300px;
          white-space: initial;
        }
        &.master-prefix {
          @include media-breakpoint-default() {
            width: 129px;
          }
        }
        .checkbox-header {
          width: fit-content;
          min-height: 36px;
          min-width: 84px;
          margin: 0;
          padding: 0 8px 0 15px;
          .custom_checkbox {
            display: flex;
            align-items: center;
            .label_name {
              color: #252422;
              @include responsive-fs(18);
              line-height: 18px;
              @include media-breakpoint-default() {
                line-height: 14px;
              }
            }
            .checkmark {
              width: 18px;
              height: 18px;
              margin-right: 7px;
              top: 50%;
              transform: translateY(-50%);
              &:after {
                left: 5px;
                bottom: 5px;
              }
            }
          }
        }
        .btn-link {
          display: flex;
          align-items: center;
          padding: 0.15em 1em;
          min-width: 104px;
          min-height: 34px;
          border: 1px solid #4E66A6;
          color: #4E66A6;
          @include responsive-fs(16);
          font-weight: bold;
          background-color: #ffffff;
          &:hover, &:active {
            text-decoration: none;
          }
          i {
            @include responsive-fs(24);
          }
          &.done {
            background-color: #4E66A6;
            color: #ffffff;
            font-weight: normal;
          }
        }
      }
    }
  }
  .table-list-upload {
    tr:last-child {
      td {
        border-bottom: 2px solid #dee2e6;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/task-type-setting/DataFormatSettingComponent.vue